<template>
  <div>
    <loader :loader="sending" />
    <template>
      <patient-information :model="model" @patientLoaded="handlePatientLoaded"/>
      <patient-interpretation-appo-info :model="model" />
      <study-background :parameters="model" />
      <interpretation-options :sending="sending" :reported="reported" :withBirads="withBirads"
        :buttonBirads="buttonBirads" :model="model" :modelDialog="modelDialog" @ReportedValue="ReportedValue"
        @validBiradsEmit="validBiradsEmit" />
      <interpretation-interpretations :model="model" :changeTemplateInterpretation="changeTemplateInterpretation"
        :isPDF="isPDF" :downloadViewer="downloadViewer" :downloadZIP="downloadZIP" :viewerOsirix="viewerOsirix"
        :downloadInterpretation="downloadInterpretation" :sending="sending" :reported="reported"
        :validBirads="validBirads" :loadingImages="loadingImages" :listTemplates="listTemplates"
        :listAllTemplatesToTable="listAllTemplatesToTable" @seeOrHideViewer="seeOrHideViewer" :images="images"
        :addImages="addImages" :saveTemplate="saveTemplate" :modelDialog="modelDialog"
        :fillinterpretation="fillinterpretation" :addImageToList="addImageToList" :dialogViewer="dialogViewer"
        :fillSaveTemplate="fillSaveTemplate"
        :closeSliderSaveTemp="closeSliderSaveTemp" :mastography="mastography" :listAllTemplates="listAllTemplates" />

      <v-expand-transition>
        <v-row v-if="dialogViewer" align="center" justify="center" class="d-flex flex-wrap text-center mb-2">
          <v-col class="col-md-2" v-for="(file, index) in images" :key="index" :id="index">
            <v-icon type="button" size="50px" color="error" @click="openPDF(file)">mdi-file-pdf-box</v-icon>
            <h3 style="text-align: center" class="mt-2 mb-2">
              Ver informe {{ index + 1 }}
            </h3>
          </v-col>
        </v-row>
      </v-expand-transition>
      <v-row align="center" justify="center" class="mt-5">
        <v-col cols="12" md="12" sm="12" class="mb-5">
        <PersonalAntecedents   :model="model.colposcopy" :cols="6" :dense="true" />
      </v-col>
        <v-col cols="12">
          <h3 class="font-weight-black mb-5">Interpretación</h3>
        </v-col>
        <v-col v-if="allowCopyPaste">
          <validation-provider v-slot="{ errors }" name="diagnostico" rules="required">
            <vue-editor v-model="interpretation" required  :error-messages="errors"
              :disabled="reported || sending"></vue-editor>
          </validation-provider>
        </v-col>
        <v-col v-if="!allowCopyPaste" @click.right.prevent @copy.prevent @paste.prevent ondrop="return false;">
          <validation-provider v-slot="{ errors }" name="diagnostico" rules="required">
            <vue-editor v-model="interpretation" @input="onEditorInput" required :error-messages="errors"
              :disabled="reported || sending"></vue-editor>
          </validation-provider>
        </v-col>
      </v-row>


      <v-row align="start" justify="start" class="mt-5">
        <v-col cols="12" md="12" sm="12">
          <v-row align="start" justify="start">

            <v-col :md="isMammography ? '6' : '12' " sm="12" >
              <h3 class="font-weight-black mb-4">Conclusión</h3>

              <v-col cols="12" v-if="!allowCopyPaste" @click.right.prevent @copy.prevent @paste.prevent
                ondrop="return false;">
                <validation-provider v-slot="{ errors }" name="conclusión" rules="required">
                  <vue-editor v-model="model.complement.conclusion" required :error-messages="errors"
                    @input="enabledButtonDownload"
                    :disabled="reported || sending"></vue-editor>
                </validation-provider>
              </v-col>
              <v-col cols="12" v-if="allowCopyPaste">
                <validation-provider v-slot="{ errors }" name="conclusión" rules="required">
                  <vue-editor v-model="model.complement.conclusion" required :error-messages="errors"
                  @input="enabledButtonDownload"
                    :disabled="reported || sending"></vue-editor>
                </validation-provider>
              </v-col>
            </v-col>

            <v-col v-if="isColposcopy" :md="isMammography ? '6' : '12'" sm="12">
  <h3 class="font-weight-black mb-4">Impresión diagnóstica</h3>
  <v-col cols="12" v-if="!allowCopyPaste" @click.right.prevent @copy.prevent @paste.prevent ondrop="return false;">
    <validation-provider v-slot="{ errors }" name="diagnosticimpression" rules="required">
      <vue-editor v-model="model.complement.diagnosticImpression" required
        :error-messages="errors" @input="enabledButtonDownload"
        :disabled="reported || sending">
      </vue-editor>
    </validation-provider>
  </v-col>
  <v-col cols="12" v-if="allowCopyPaste">
    <validation-provider v-slot="{ errors }" name="diagnosticimpression" rules="required">
      <vue-editor v-model="model.complement.diagnosticImpression" required
        :error-messages="errors" @input="enabledButtonDownload"
        :disabled="reported || sending">
      </vue-editor>
    </validation-provider>
  </v-col>
</v-col>



            <v-col md="5" sm="12"  v-if="isMammography">
              <h3 class="font-weight-black mb-4">Conducta a seguir</h3>

              <v-row>
                <v-col cols="12">
                  <label>
                   Realizar toma de ultrasonido: 
                    <v-icon class="ml-4" @click="model.complement.ultrasound = null">
                    {{ $cnst.CLEAR_ICON }}
                  </v-icon> 
                  </label>
                  <v-radio-group  dense row
                    v-model="model.complement.ultrasound">
                    <v-radio label="SI" value="true"></v-radio>
                    <v-radio label="NO" value="false"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>

              <validation-provider v-slot="{ errors, valid }" name="Próxima detección por mastografía en años" rules="">
                
                <v-autocomplete label="Próxima detección por mastografía en años:"
                  v-model="model.complement.nextDetection" :error-messages="errors"  
                  clearable :items="periods">
                  <v-icon slot="append" :color="valid ? 'success' : ''">
                    {{ valid && model.complement.nextDetection ? " mdi-check" : "mdi-chevron-down" }}
                  </v-icon>
                </v-autocomplete>
              </validation-provider>
             
              <v-row>
                <v-col cols="12">
                  <label>
                    Referencia a ginecología a tratamiento de patología benigna: 
                    <v-icon class="ml-4" @click="model.complement.hasReference = null">
                    {{ $cnst.CLEAR_ICON }}
                  </v-icon> 
                  </label>
                  <v-radio-group  dense row
                    v-model="model.complement.hasReference">
                    <v-radio label="SI" value="true"></v-radio>
                    <v-radio label="NO" value="false"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              

              <validation-provider v-slot="{ errors, valid }" name="Referencia a evaluación diagnóstica a unidad"
                rules="max:200">
                <v-text-field label="Referencia a evaluación diagnóstica a unidad" :counter="200" maxlength="200"
                  v-model.trim="model.complement.referenceEvaluation" clearable :error-messages="errors" dense
                  :clear-icon="$cnst.CLEAR_ICON">
                  <v-icon slot="append" :color="valid ? 'success' : ''">
                    {{ valid && model.complement.referenceEvaluation ? " mdi-check" : "" }}
                  </v-icon>
                </v-text-field>
              </validation-provider>

              
              <validation-provider v-slot="{ errors, valid }" name="Fecha de referencia" v-if="model.complement.referenceEvaluation || $utilFront.isNonNull(model.complement.hasReference)">
                <v-text-field class="mt-8" v-model.trim="model.complement.referenceDate" label="Fecha de referencia"
                  autocomplete="off" dense clearable disabled
                  :error-messages="errors" :clear-icon="$cnst.CLEAR_ICON" type="text">
                  <v-icon slot="append" :color="valid ? 'success' : ''">
                    {{ valid && model.complement.referenceDate ? " mdi-check" : "" }}
                  </v-icon>
                </v-text-field>
              </validation-provider>

            </v-col>

          </v-row>

        </v-col>

      </v-row>
      <v-row align="center" justify="center" class="mt-5">
        <v-col cols="6">
          <v-row align="center" justify="center">
            <v-col cols="8">
              <validation-provider v-slot="{ errors }" name="adjuntar archivos" rules="maxSizeFile">
                <v-file-input v-model="files" placeholder="Seleccione los archivos" label="Adjuntar archivos" multiple
                  show-size counter prepend-icon="mdi-paperclip" :disabled="reported"
                  :error-messages="errors"></v-file-input>
              </validation-provider>
            </v-col>
          </v-row>
          <v-row class="d-flex flex-nowrap" align="start" justify="center">
            <v-col cols="2" class="text-center" v-for="(file, index) in files" :key="index">
              <div class="d-flex flex-column justify-center">
                <div class="d-flex justify-end">
                  <v-btn icon @click="deleteFile(file.name)">
                    <v-icon size="24px" color="error">mdi-close</v-icon>
                  </v-btn>
                </div>
                <v-icon style="font-size: 11vh; text-align: center" size="100px" :color="file.type === 'application/pdf'
      ? 'error'
      : 'grey' || file.type === 'image/jpeg'
        ? 'secondary'
        : 'grey'
      ">{{
      file.type === "application/pdf"
        ? "mdi-file-pdf-box"
        : "mdi-file" || file.type === "image/jpeg"
          ? "mdi-image"
          : "mdi-file"
                  }}</v-icon>
                <h1 style="font-size: 120%; text-align: center">
                  {{ file.name }}
                </h1>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
import PatientInterpretationAppoInfo from "@/app/components/interpretation/PatientInterpretationAppoInfo.vue";
import StudyBackground from "@/app/components/interpretation/StudyBackground.vue";
import InterpretationOptions from "@/app/components/interpretation/InterpretationOptions.vue";
import InterpretationInterpretations from "@/app/components/interpretation/InterpretationInterpretations.vue";
import InterpretationReportDialog from "@/app/components/interpretation/InterpretationReportDialog.vue";
import PersonalAntecedents from "@/app/components/optometry/common/PersonalAntecedents.vue";
import Loader from "@/app/components/base/loader/Loader.vue";
import {
  ReportPDFRequest,
  StudyRequest,
  DownloadZipRequest,
  PacsConfigurationRequest
} from "@/core/request";
import { TemplateDialogService } from "@/app/services";
import ConfigurationService from "@/app/services/ConfigurationService";
import { UtilFront } from "@/core/";

import { ValidationProvider } from "vee-validate";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    PatientInformation,
    StudyBackground,
    PatientInterpretationAppoInfo,
    InterpretationOptions,
    InterpretationInterpretations,
    InterpretationReportDialog,
    PersonalAntecedents,
    ValidationProvider,
    VueEditor,
    Loader,
  },
  props: {
    model: Object,
    modelDialog: Object,
    buttonBirads: Boolean,
    saveFilesChanges: Boolean,
    mastography: Boolean,
    isMammography: Boolean,
  },
  data() {
    return {
      files: undefined,
      sending: false,
      invalidSign: true,
      reported: false,
      withBirads: false,
      loadingImages: false,
      validBirads: false,
      dialogViewer: false,
      menu: false,
      listTemplates: [],
      listAllTemplatesToTable: [],
      interpretation: "",
      images: [],
      imagesToAdd: [],
      mapping: [],
      colposcopyData: [],
      fillinterpretation: false,
      fillSaveTemplate: false,
      closeSliderSaveTemp: false,
      flag: 0,
      allowCopyPaste: false,
      supplementaryConclusionMg: "",
      complementInit: {
        conclusion: null,
        diagnosticImpression: null,
        nextDetection: null,
        hasReference: null,
        referenceEvaluation: null,
        referenceDate: null,
        ultrasound: null
      },
      periodsBirads:[
        {text: "6 MESES", value: "6 MESES", birads: ["3"]},
        {text: "1 AÑO",value: "1 AÑO", birads: ["0","1","2","3","4","5","6"]},
        {text: "2 AÑOS",value: "2 AÑOS", birads: ["0","1","2","3","4","5","6"]},
      ],
      periods: [
      ]
    };
  },
  mounted() {
    this.listAllTemplates();
    this.findAllImagesByStudy();
    this.validBirads = this.$utilFront.nonEmpty(this.model.birads);
    this.specialCharacter();
    this.findConfigurations();
    this.setValues();
    this.validPeriodsBirads();
    console.log("[FORM REVALIDACION PENDING] mounted", {
    route: this.$route.name,
    idStudy: this.model?.idStudy,
    idInterpretation: this.model?.idInterpretation
  });
  },
  watch: {
    saveFilesChanges: function () {
      if (this.saveFilesChanges) {
        this.setFilesToModel();
      }
    },
    interpretation: function () {
      this.enabledButtonDownload();
      this.enableButtonTemplate();
    },
    model(newVal, oldVal){
      console.log(`myProp changed from ${oldVal} to ${newVal}`);
    },
    model: {
    immediate: true,
    handler(newVal) {
      console.log("[FORM REVALIDACION PENDING] model cambió", {
        idStudy: newVal?.idStudy,
        idInterpretation: newVal?.idInterpretation
      });
    }
  }
  },
  computed: {
  isColposcopy() {
    // Asumiendo que model.modality tiene el valor "COLPOSCOPIA"
    return this.model.nameModality && this.model.nameModality.toUpperCase() === 'COLPOSCOPIA';
  }
},
  methods: {
    validPeriodsBirads(){
      let currentBirads = this.model?.birads?.name;
      this.periods = this.periodsBirads.filter(item => 
          this.$utilFront.isNull(currentBirads) || 
          item.birads.some(birad => currentBirads.includes(birad))
      );
      if(this.$utilFront.isNonNull(this.model.complement) && this.$utilFront.nonEmpty(this.model.complement.nextDetection)){
        let valueSelected = this.model.complement.nextDetection;
        if(!this.periods.some(period=> period.value === valueSelected)){
          this.$utilFront.notifications(`${valueSelected} no disponible en campo próxima detección.`, "ERROR" );
          this.model.complement.nextDetection = null;
        }
      }
    },  
    setValues(){
      if(this.isMammography){
        this.model.complement.referenceDate = this.$utilFront.formatDate(new Date(), 1);
      }
    },
    onEditorInput(html) {
      const plain = html.replace(/<[^>]*>/g, '')
      if (!plain.trim()) {
         this.model.interpretation = ''
      } else {
        this.model.interpretation = html
      }
    },
    enabledButtonDownload(){
      const textOne = (this.$utilFront.nonEmpty(this.interpretation) ? this.interpretation : "").replace(/<.*?>/g, "").replace(/\s+/g, "");
      const textTwo = (this.$utilFront.isNonNull(this.model.complement) ? (this.model.complement.conclusion || ""): "").replace(/<.*?>/g, "").replace(/\s+/g, "");
      this.fillinterpretation = this.$utilFront.nonEmpty(textOne.trim()) && this.$utilFront.nonEmpty(textTwo.trim());
    },
    enableButtonTemplate(){
      const textOne = (this.$utilFront.nonEmpty(this.interpretation) ? this.interpretation : "").replace(/<.*?>/g, "").replace(/\s+/g, "");
      this.fillSaveTemplate = this.$utilFront.nonEmpty(textOne.trim()) 
    },
    findConfigurations() {
      ConfigurationService.findConfigurationCopyPasteInterpretation({ idBranchOffice: null }).then((response) => {
        let { data, status } = response;
        this.allowCopyPaste = data?.allowCopyPaste || false;
      }).catch(this.catchError)
        .finally(() => { });

      PacsConfigurationRequest.getConfigAppReport({ idBranchOffice: this.$utilFront.getIdBranchOffice() }).then(({data}) => {
        this.supplementaryConclusionMg = data.data?.supplementaryConclusionMg || "";
        if(this.isMammography){
          this.model.complement.conclusion = `${this.supplementaryConclusionMg}`;
        }
      }).catch(this.catchError)
        .finally(() => { });

    },
    deleteFile(fileName) {
      let i = this.files.findIndex((index) => index.name === fileName);
      if (i > -1) {
        this.files.splice(i, 1);
      }
    },
    openDialog(typeDialog) {
      this.typeDialog = typeDialog;
      this.dialog = true;
    },
    specialCharacter() {
      let from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç",
        to = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc";

      for (let i = 0, j = from.length; i < j; i++) {
        this.mapping[from.charAt(i)] = to.charAt(i);
      }
    },
    /**emits */
    ReportedValue(value) {
      this.reported = value;
      this.$emit("returnTable", true);
    },
    seeOrHideViewer(value) {
      this.dialogViewer = value;
    },
    validBiradsEmit(value, biradsSelected) {
      this.validBirads = value;
      this.$emit("ActiveButtonSave", value);
      this.validPeriodsBirads();
    },
    /** */
    async setFilesToModel() {
      // let filesList = [];
      // if (this.files != null && this.files.length != 0) {
      //   for (let file of this.files) {
      //     const value = await this.getBase64(file);
      //     filesList.push(value);
      //   }
      // }
      this.model.filesList = this.files;
      this.model.interpretation = this.interpretation;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        try {
          let reader = new FileReader();
          //for (let file of files) {
          reader = new FileReader();
          let fileByte = [];
          reader.readAsArrayBuffer(file);
          reader.onload = (evt) => {
            if (evt.target.readyState == FileReader.DONE) {
              let arrayBuffer = evt.target.result,
                array = new Uint8Array(arrayBuffer);
              for (let byte of array) {
                fileByte.push(byte);
              }
            }
            let c = "";
            for (var i = 0, j = file.name.length; i < j; i++) {
              var l = file.name.charAt(i);
              c = c + (l in this.mapping ? this.mapping[l] : l);
            }
            let te = c.replace(/[^a-zA-Z0-9-_+{}()&$!#%. ]/g, "");
            let f = {
              bytes: fileByte,
              fileName: te,
              type: file.type,
            };
            //this.filesToSave.push(f);
            resolve(f);
          };
          reader.onerror = function (error) {
            this.$utilFront.notifications(
              "Error al procesar archivo: " + file.name,
              "ERROR"
            );
          };
          //}
          reader.onloadend = (end) => {
            //this.add();
          };
        } catch (e) {
        } finally {
        }
      });
    },
    findAllImagesByStudy() {
      let data = {
        idStudy: this.model.idStudy,
      };
      this.loadingImages = true;
      StudyRequest.findAllImagesByStudy(data)
        .then((res) => {
          let data = res.data;
          this.images = data.data;
        })
        .finally(() => {
          this.loadingImages = false;
        });
    },
    listAllTemplates() {
      this.listTemplates = [];
      let params = {
        idModality: this.model.idModality,
      };
      TemplateDialogService.listAllTemplates(params)
        .then((res) => {
          let { data, status, code } = res;
          this.listAllTemplatesToTable = data;
          this.listTemplates = data.map((obj) => {
            return {
              value: obj,
              text: obj.name + " (" + obj.idTemplateInterpretation + ")",
            };
          });
        })
        .catch(this.catchError)
        .finally(() => { });
    },
    saveTemplate() {
      this.sending = true;
      let regex = /<img[^>]*>/g;
      let text = this.interpretation.replaceAll(regex, "");
      let data = {
        templateHTML: text,
        name: this.modelDialog.nameTemplate,
        type: this.modelDialog.typeTemplate,
        // idHumanResource: this.$utilFront.getIdHumanResource(),
        idModality: this.model.idModality,
      };
      TemplateDialogService.add(data)
        .then((res) => {
          this.modelDialog.nameTemplate = "";
          this.modelDialog.typeTemplate = null;
          this.$utilFront.notifications(
            "Plantilla registrada correctamente.",
            "SUCCESS"
          );
          this.listAllTemplates();
          this.closeSliderSaveTemp = true;
        })
        .catch(() => {
          this.$utilFront.notifications(
            "Error al registrar plantilla.",
            "ERROR"
          );
        })
        .finally(() => {
          this.modelDialog.nameTemplate = "";
          this.modelDialog.typeTemplate = null;
          this.closeSliderSaveTemp = false;
          this.sending = false;
        });
    },
    changeTemplateInterpretation(eventtl) {
      if (eventtl != null) {
        let setTemplate = eventtl.templateHTML;
        setTemplate = setTemplate
          .replaceAll("<div>", "<p>")
          .replaceAll("</div>", "</p>");
        this.interpretation = setTemplate;
      } else {
        this.interpretation = "";
      }
    },
    isPDF() {
      return (
        this.model.acronymModality == "ECG" ||
        this.model.acronymModality == "DXA"
      );
    },
    downloadViewer(item) {
      this.sending = true;
      let data = {
        idStudy: item.idStudy,
        idBranchOffice: this.$utilFront.getIdBranchOffice(),
      };
      StudyRequest.findURLJNLP(data)
        .then((res) => {
          window.open(res.data, "_blank").focus();
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
    },
    viewerOsirix(item) {
      this.sending = true;
      let data = { idStudy: item.idStudy };
      ConfigurationService.findConfigurationOsirixPath(data).then((res) => {
        window.open(res.data, "_blank").focus();
      }).catch((error) => {
        UtilFront.errorhttp(error);
      })
        .finally(() => {
          this.sending = false;
        });
    },
    downloadZIP(item) {
      this.sending = true;
      let data = { idStudy: item.idStudy };
      DownloadZipRequest.downloadImagesDCM(data)
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/zip",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", item.idStudy + ".zip");
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
    },
    downloadInterpretation() {
      this.sending = true;
      let data = {
        idInterpretation: null,
        interpretationText: this.model.interpretation,
        complement:  this.model.complement,
        idStudy: this.model.idStudy,
        fileName: "Interpretacion",
        idBirads: this.model?.birads?.idBirads,
        // note: this.model.note,
        // findingLocationTypeList: this.model.findingLocationTypeList,
      };
      ReportPDFRequest.downloadInterpretation1(data).then((res) => {
        if (res.status == 200 && res.data.type != "application/json") {
          this.$utilFront.openPDF(res.data);
        } else {
          this.$utilFront.displayErrorPdf(res.data);
        }
      });
      this.sending = false;
    },
    async openPDF(file) {
      let w = window.open("about:blank");
      setTimeout(function () {
        w?.document.write(`
            <!DOCTYPE html>
              <head>
              <title>Informe</title>
              </head>
              <body>
              <img src="${file.url}" width="70%">
              </body>
            </html>`);
      }, 0);
    },
    addImageToList(n) {
      if (n.added) {
        let indexSearch = this.imagesToAdd.indexOf(n);
        if (indexSearch == -1) {
          this.imagesToAdd.push(n);
        }
      } else {
        let indexSearchRemove = this.imagesToAdd.indexOf(n);
        if (indexSearchRemove > -1) {
          this.imagesToAdd.splice(indexSearchRemove, 1);
        }
      }
    },
    addImages() {
      let imagetoupload = this.imagesToAdd;
      this.imagesToAdd = [];
      if (this.flag == 0) {
        this.listaddedImages = imagetoupload;
        let tableHTML = `<p style='display: flex; flex-wrap: wrap; align-items: center; justify-content: center;'>`;
        for (let i in this.listaddedImages) {
          const element = this.listaddedImages[i];
          let imageHTML = `<img src='${element.url}' style='width: 250px; margin:10px'/>`;
          tableHTML += `${imageHTML}`;
        }
        tableHTML += `</p>`;
        let interpretationHTML = this.interpretation;
        interpretationHTML += tableHTML;
        this.interpretation = interpretationHTML;
        this.flag = 1;
      } else if (this.flag == 1) {
        let tableHTML = `<p style='display: flex; flex-wrap: wrap; align-items: center; justify-content: center;'>`;
        for (let i in imagetoupload) {
          const element = imagetoupload[i];
          let imageHTML = `<img src='${element.url}' style='width: 250px; margin:10px'/>`;
          tableHTML += `${imageHTML}`;
        }
        tableHTML += `</p>`;
        let interpretationHTML = this.interpretation;
        interpretationHTML += tableHTML;
        this.interpretation = interpretationHTML;
      }
      this.dialogImages = false;
    },
  handlePatientLoaded(patientData) {
    this.model.idPerson = patientData.person.id;
  },
  },
};
</script>

<style></style>
